import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import './SidebarLayout.css';

class SidebarLayout extends Component {
  static get propTypes() {
    return {
      pullRight: PropTypes.bool,
      children: PropTypes.element.isRequired,
      sidebarComponent: PropTypes.element.isRequired,
      xsHiddenDown: PropTypes.bool,
      smHiddenDown: PropTypes.bool,
      mdHiddenDown: PropTypes.bool,
      lgHiddenDown: PropTypes.bool,
      xlHiddenDown: PropTypes.bool,
      newLayout: PropTypes.bool
    };
  }

  render() {
    const classes = classNames(this.props.className, {
      'hidden-xs-down': this.props.xsHiddenDown,
      'hidden-sm-down': this.props.smHiddenDown,
      'hidden-md-down': this.props.mdHiddenDown,
      'hidden-lg-down': this.props.lgHiddenDown,
      'hidden-xl-down': this.props.xlHiddenDown
    });
    const { newLayout } = this.props;

    return (
      <div
        className={classNames('SidebarLayout row', {
          'new-layout': newLayout
        })}
      >
        {newLayout ? (
          <div className={`col col-md-3 px-0 ${classes}`.trim()}>
            <aside id="sidebar">{this.props.sidebarComponent}</aside>
          </div>
        ) : (
          <aside id="sidebar" className={`col col-md-3 px-0 ${classes}`.trim()}>
            {this.props.sidebarComponent}
          </aside>
        )}

        <div
          className={classNames('content-wrapper col col-md-9 mb-5 mb-md-3', {
            'offset-md-3': !newLayout
          })}
        >
          {this.props.children}
        </div>
      </div>
    );
  }
}

export default SidebarLayout;



// WEBPACK FOOTER //
// ./src/components/layouts/SidebarLayout/SidebarLayout.js